<template>
  <div class="index">
    <div class="banner">
      <img src="@/assets/images/indexbanner.jpg" alt="">
    </div>
    <div class="bgc">
      <div class="bx-content">
        <div class="box-item">
          <div class="item-title">
            <b>取得科技类非学科校外培训机构培训许可证教培机构名单</b>
          </div>
          <div class="item-list">
            <p class="ovHide" v-for="item in chi" :key="item.id" @click="showMask(item)">{{item.org_name}}</p>
            <span @click="to('/masses/orgList','',1)" class="more">查看更多 +</span>
          </div>
        </div>

        <div class="box-item zijin">
          <div class="item-title ">
            <b>开通预收资金专用存管账户机构名单</b>
          </div>
          <div class="item-list">
            <p class="ovHide" v-for="item in kai" :key="item.id" @click="showMask(item)">{{item.org_name}}</p>
            <span @click="to('/masses/orgList','',2)">查看更多 +</span>
          </div>
        </div>

        <div class="item-flex">
          <div class="item-box">
            <b>教培机构星级评定名单</b>
            <span @click="$message.info('暂未开放...')">查看更多 +</span>
          </div>
          <div class="item-box fengxian" @click="$message.info('暂未开放...')">
            <b>教培机构风险预警名单</b>
             <span>查看更多 +</span>
          </div>
        </div>
      </div>
    </div>

    <div class="bx-content">
      <div class="title-box">
        <div class="title-tex">
          <b>宣传信息</b>
          <p>SPREAD INFORMATION</p>
        </div>
        <div class="more" @click="to('/masses/publicizeList','',3)">查看更多 +</div>
      </div>
      <div class="flex-list margin-top">
        <div class="flex-left" v-if="one">
          <div class="left-img">
            <img :src="one.thumb" alt="">
          </div>
          <div class="left-time">
            <i class="iconfont icon-date"></i>{{one.publish_time}}
          </div>
          <div class="left-title ovHide2">{{one.title}}</div>
          <div class="left-more" @click="to('/masses/detail',one.id,3)">
            查看详情 <i class="iconfont icon-jiantouyou"></i>
          </div>
        </div>
        <div class="flex-right">
          <div class="item" v-for="item in right" :key="item.id" @click="to('/masses/detail',item.id,3)">
            <div class="item-img">
              <img :src="item.thumb" alt="">
            </div>
            <div class="item-cont">
              <div class="item-time">
                <i class="iconfont icon-date"></i>{{item.publish_time}}
              </div>
              <div class="item-title ovHide2">{{item.title}}</div>
              <div class="item-more" >
                查看详情 <i class="iconfont icon-jiantouyou"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bgc">
      <div class="bx-content">
        <div class="item-flex p0">
          <div class="item-box zhengce" @click="to('/masses/policyList','',1)">
            <b>政策法规</b>
            <span>查看更多 +</span>
          </div>
          <div class="item-box keji" @click="to('/masses/technologyList','',5)">
            <b>科技专栏</b>
            <span>查看更多 +</span>
          </div>
        </div>
      </div>
    </div>
    <orgDetailDialog :dialogVisible="dialogVisible" :item="item" @handleClose="handleClose" />
  </div>
</template>
<script>
import {masses_index} from "@/api";
import orgDetailDialog from "@/views/masses/common/orgDetailDialog";
export default {
  name: "index",
  data() {
    return {
      dialogVisible:false,
      item:{},
      chi:[],
      kai:[],
      one:[],
      right:[]
    }
  },
  components: {orgDetailDialog},
  created() {
    this.init()
  },
  methods: {
    async init(){
      let _data = await masses_index();
      if(_data.status == 200){
        this.chi = _data.data.chi;
        this.kai = _data.data.kai;
        this.one = _data.data.one;
        this.right = _data.data.right;
      }
    },
    to(path,id,type){
      this.$router.push({
        path: path,
        query: {
          id: id,
          type: type
        }
      })
    },

    showMask(item) {
      this.item = item;
      this.dialogVisible = true;
    },
    handleClose(){
      this.dialogVisible = false
      this.item = {}
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.index {
  .flex-list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-bottom: 75px;
    .flex-right {
      width: 738px;
      //height: 705px;
      //overflow-y: hidden;
      .item {
        width: 100%;
        background-image: linear-gradient(0deg,
          #ffffff 84%,
          #eff7ff 100%);
        box-shadow: 11px 8px 18px 0px
        rgba(0, 46, 108, 0.17);
        border-radius: 8px;
        border: solid 1px #ffffff;
        padding: 20px;
        display: flex;
        justify-content: flex-start;
        margin-bottom: 25px;
        &:nth-child(3n) {
          margin-bottom: 0;
        }
        .item-cont {
          flex: 1;
          width: 0;
          height: 176px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          padding: 2px 0;
          .item-more {
            width: 110px;
            height: 38px;
            background-image: linear-gradient(0deg,
              #2791ff 0%,
              #81b6ff 100%);
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #ffffff;
            cursor: pointer;
            i {
              font-size: 14px;
              color: #ffffff;
              margin-left: 10px;
            }
          }
          .item-title {
            width: 100%;
            font-size: 18px;
            color: #141c24;
            margin-top: 20px;
            margin-bottom: 40px;
          }
          .item-time {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 14px;
            color: #999999;
            i {
              font-size: 18px;
              color: #999999;
              margin-right: 10px;
            }
          }
        }
        .item-img {
          width: 220px;
          height: 176px;
          background-color: #f8faff;
          border-radius: 8px;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
          }
        }
      }
    }
    .flex-left {
      width: 736px;
      height: 705px;
      background-image: linear-gradient(0deg,
        #ffffff 84%,
        #eff7ff 100%);
      box-shadow: 11px 8px 18px 0px
      rgba(0, 46, 108, 0.17);
      border-radius: 8px;
      border: solid 1px #ffffff;
      padding: 25px 30px;
      .left-title {
        width: 100%;
        font-size: 18px;
        color: #0d7bff;
      }
      .left-more {
        width: 110px;
        height: 38px;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #4698fb;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #4698fb;
        font-size: 14px;
        margin-top: 45px;
        cursor: pointer;
        i {
          font-size: 18px;
          color: #4698fb;
          margin-left: 10px;
        }
      }
      .left-time {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;
        color: #999999;
        padding: 15px 0;
        i {
          font-size: 20px;
          color: #999999;
          margin-right: 10px;
        }
      }
      .left-img {
        width: 100%;
        height: 446px;
        border-radius: 8px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px;
        }
      }
    }
    .flex-right {}
  }
  .title-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 65px;
    .more {
      font-size: 18px;
      color: #4698fb;
      cursor: pointer;
    }
    .title-tex {
      p {
        display: block;
        font-size: 16px;
        color: #999999;
        letter-spacing: 1px;
      }
      b {
        display: block;
        font-size: 40px;
        color: #4698fb;
        font-weight: bold;
        line-height: 48px;
      }
    }
  }
  .bgc {
    width: 100%;
    padding: 100px 0;
    background: #ebf4ff;
    .item-flex {
      width: 100%;
      padding-top: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &.p0 {
        padding-top: 0;
      }
      .item-box {
        width: 738px;
        height: 138px;
        background: url("../../../assets/images/xingjititle.png") no-repeat;
        background-size: 100% 100%;
        padding-left: 47px;
        padding-right: 144px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.zhengce {
          background: url("../../../assets/images/zhengfatitle.png") no-repeat;
          background-size: 100% 100%;
          padding-right: 154px;
        }
        &.keji {
          background: url("../../../assets/images/kejititle.png") no-repeat;
          background-size: 100% 100%;
          padding-right: 164px;
        }
        &.fengxian {
          background: url("../../../assets/images/fengxiantitle.png") no-repeat;
          background-size: 100% 100%;
          padding-right: 170px;
        }
        b {
          font-size: 34px;
          letter-spacing: 1px;
          color: #ffffff;
          font-weight: bold;
        }
        span {
          font-size: 18px;
          color: #ffffff;
          height: 39px;
          border-bottom: 1px solid #ffffff;
          line-height: 39px;
          cursor: pointer;
        }
      }
    }
    .box-item {
      width: 100%;
      min-height: 352px;
      background-image: linear-gradient(0deg,
        #e7fcff 0%,
        #ffffff 100%);
      box-shadow: 11px 8px 18px 0px
      rgba(0, 46, 108, 0.17);
      border-radius: 8px;
      .item-list {
        width: 100%;
        min-height: 215px;
        padding: 20px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        span {
          width: 465px;
          height: 70px;
          background-color: #ffffff;
          box-shadow: 0px 0px 16px 0px
          rgba(7, 65, 149, 0.05);
          border-radius: 10px;
          padding: 0 25px;
          margin: 10px;
          line-height: 70px;
          font-size: 26px;
          color: #7ad5dd;
          text-align: center;
          cursor: pointer;
        }
        p {
          width: 465px;
          height: 70px;
          background-color: #ffffff;
          box-shadow: 0px 0px 16px 0px
          rgba(7, 65, 149, 0.05);
          border-radius: 10px;
          padding: 0 25px;
          margin: 10px;
          line-height: 70px;
          font-size: 22px;
          color: #64676d;
          cursor: pointer;
        }
      }
      .item-title {
        width: 100%;
        height: 138px;
        background: url("../../../assets/images/jigoutitle.png") no-repeat;
        background-size: 100% 100%;
        line-height: 138px;
        padding-left: 45px;

        b {
          font-size: 32px;
          letter-spacing: 1px;
          color: #ffffff;
          font-weight: bold;
        }
      }
      &.zijin {
        background-image: linear-gradient(0deg,
          #e1eeff 0%,
          #ffffff 100%);
        box-shadow: 11px 8px 18px 0px
        rgba(0, 46, 108, 0.17);
        margin-top: 50px;
        .item-title {
          background: url("../../../assets/images/zijintitle.png") no-repeat;
          background-size: 100% 100%;
        }
        .item-list {
          span {
            color: #67aeff;
          }
        }
      }
    }
  }

  .banner {
    width: 100%;

    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>


